import { EventEmitter, Injectable } from '@angular/core';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { NavigationEnd } from '@angular/router';
import { BreadCrumb } from '@client-models/breadcrumb.model';
import { AppointmentReservationBody } from '@constants/appointment-reservation.model';
import { CalendarAppointmentModel, CustomFieldValueRequestBody } from '@db-models/calendar-appointment.model';
import { CustomerCustomField, CustomFieldModel } from '@db-models/custom-field.model';
import { SmartWidgetModel, SmartWidgetStepModel } from '@db-models/smart-widget.model';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CalioEventsService {

  addEventSlotsEvent = new EventEmitter<any>();
  toggleMobileMenu = new EventEmitter<boolean>();
  closeMobileMenu = new EventEmitter<boolean>();
  hideGlobalSearchEvent = new EventEmitter<boolean>();
  gotoSettingsRightSectionEvent = new EventEmitter<any>();
  closeCalioDialogEvent = new EventEmitter<any>();
  closeCalioRefDialogEvent = new EventEmitter<any>();
  onToggleButton = new EventEmitter<MatSlideToggleChange>();
  calioDialogTitleChangedEvent = new EventEmitter<{
    title?: string,
    subtitle?: string
  }>();
  calioDashboardHeaderDataChanged = new EventEmitter<{
    title: string,
    subtitle: string,
    breadcrumbs: BreadCrumb[],
    permissionTypes?: string | string[],
    showLastItemCustomLabel?: boolean,
    lastItemCustomLabel?: string,
    isTitleNotTranslatable?: boolean,
    showHelpIcon?: boolean,
    helpUrl?: string,
    showLoomIcon?: boolean,
    loomUrl?: string,
    tooltipTitle?: string,
  }>();
  resetIsMultiDayToggleButton = new EventEmitter<any>();
  resetWebsiteIntegrationWidgetConfigEvent = new EventEmitter<any>();
  resetBookingPageConfigEvent = new EventEmitter<any>();
  updateSmartWidgetEvent = new EventEmitter<{ smartWidgetData: SmartWidgetModel }>();
  nextStepperStepEvent = new EventEmitter<{ smartWidgetData: SmartWidgetModel }>();
  previousStepperStepEvent = new EventEmitter<{ smartWidgetData: SmartWidgetModel }>();
  bookingQuestionReorderingEvent = new EventEmitter<{ selectedCustomFields: CustomFieldModel[], pageType: string, stepDbModel?: SmartWidgetStepModel }>();
  bookingQuestionUpdatedOnLandingPageEvent = new BehaviorSubject<boolean>(false);
  bookingQuestionsPayloadOnLandingPageEvent = new Subject<{ [key: string]: CustomFieldValueRequestBody }>();
  bookingQuestionCancelEditOnLandingPageEvent = new Subject<boolean>();
  routeChangedEvent$ = new EventEmitter<NavigationEnd>();
  reservedAppointmentEvent = new EventEmitter<AppointmentReservationBody>();
  toggleAppointmentStatusEvent = new EventEmitter<boolean>();
  saveAppointmentEvent = new EventEmitter<void>();
  // Carries the just-saved appointment so the booking-questions step closes the dialog with the
  // persisted record (uuid + id) instead of the pre-save model it captured in ngOnInit, and whether
  // the admin wrote the description in that save, so the answers save does not rebuild it.
  bookingQuestionsSaveTriggerEvent = new EventEmitter<{ appointment: CalendarAppointmentModel; keepDescription: boolean }>();
  appointmentLoadingEvent = new EventEmitter<boolean>();
  uploadPendingFilesEvent = new EventEmitter<{ appointmentId: number, appointmentUuid: string, uploadResults?: Observable<CustomerCustomField[] | null>[] }>();
  placeholderValuesChangedEvent = new EventEmitter<void>();
}
